module.exports = __webpack_public_path__ + "img/I-16.b3ff93d4.svg";